import React from 'react';
const SearchBarSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g id="Group 20823">
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.08932C0 4.06945 4.06945 0 9.08932 0C14.1092 0 18.1786 4.06945 18.1786 9.08932C18.1786 14.1092 14.1092 18.1786 9.08932 18.1786C4.06945 18.1786 0 14.1092 0 9.08932ZM9.08932 1.47394C4.88349 1.47394 1.47394 4.88349 1.47394 9.08932C1.47394 13.2952 4.88349 16.7047 9.08932 16.7047C13.2952 16.7047 16.7047 13.2952 16.7047 9.08932C16.7047 4.88349 13.2952 1.47394 9.08932 1.47394Z"
          fill={color}
        />
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.78887 5.29752C6.63275 4.4537 7.80062 3.93048 9.08929 3.93048C10.378 3.93048 11.5458 4.45369 12.3897 5.29753C12.6775 5.58534 12.6775 6.05196 12.3897 6.33977C12.1019 6.62758 11.6352 6.62758 11.3474 6.33977C10.7687 5.76106 9.97135 5.40443 9.08929 5.40443C8.20723 5.40443 7.40984 5.76106 6.83107 6.33979C6.54325 6.62758 6.07663 6.62757 5.78883 6.33975C5.50104 6.05194 5.50105 5.58531 5.78887 5.29752Z"
          fill={color}
        />
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.573 14.5729C14.8608 14.2851 15.3275 14.2851 15.6153 14.5729L19.7842 18.7419C20.072 19.0297 20.072 19.4963 19.7842 19.7841C19.4964 20.0719 19.0298 20.0719 18.742 19.7841L14.573 15.6151C14.2852 15.3273 14.2852 14.8607 14.573 14.5729Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default SearchBarSVG;
